const DEV_CONFIG = require('./dev.js');
const QA_CONFIG = require('./qa.js');
const PREPROD_CONFIG = require('./preprod.js');
const PRODUCTION_CONFIG = require('./production.js');
const PRODUCTION_CN_CONFIG = require('./production-cn.js');

const buildConfigs = [
  DEV_CONFIG,
  QA_CONFIG,
  PREPROD_CONFIG,
  PRODUCTION_CONFIG,
  PRODUCTION_CN_CONFIG,
];

const getEnv = envName => process.env[envName] && process.env[envName].trim().toLowerCase();

const configs = buildConfigs.find(
  config => config.buildEnv === getEnv('BUILD_ENV') && (
    config.site === (getEnv('SITE') || 'global')
  )
);

module.exports = {
  configs,
};
